import { CallStateEnum } from '@models/call-state.model.ts';

export function withCallState(getState: any) {
  return {
    isLoading: () => getState().callState === CallStateEnum.Loading,
    isError: () => getState().callState === CallStateEnum.Error,
    isLoaded: () => getState().callState === CallStateEnum.Loaded
  };
}

export type CallStateMethods = {
  isLoading: () => boolean;
  isError: () => boolean;
  isLoaded: () => boolean;
};

export type CallStateMethodNames = {
  isLoading: 'isLoading';
  isError: 'isError';
  isLoaded: 'isLoaded';
};
